export default __webpack_public_path__ + "static/media/exam-review-submit.29e40962.svg";